import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {schemaOrderLaundry} from '../../../../../util/validationLavanderia'
import {LaundryModel} from '../../../model'
import {useAuth} from '../../../../../hooks/useAuth'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {TabLavanderiaModel} from '../../../../../models'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {createLaundry, deleteLaundry, updateLaundry, uploadTicket} from '../../../services'
import {renderPanelContent} from '../components'
import {getUTCDate} from '../../../util/functions'
import Swal from 'sweetalert2'
import {ShowSnackBar} from '../../../../../util/functions'
import {ModalReception} from '../LaundryReceptionWrapper/Modal/ModalReception'

const LaundryPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {user} = useAuth()
  const [loading, setLoading] = useState(false)
  const methods = useForm<LaundryModel>({
    resolver: yupResolver(schemaOrderLaundry),
  })
  const [show, setShow] = useState(false)
  const {reset} = methods
  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        let id = currentTabItem.laundrySelected ? currentTabItem.laundrySelected[0]?.id : ''
        if (!id) return
        try {
          const data = await deleteLaundry(id)
          if (!data.data.error) {
            const obj: TabLavanderiaModel = {
              ...currentTabItem,
              idToDelete: '',
              loadingTable: true,
            }
            changeCurrentTabItem(obj)
            ShowSnackBar('Se eliminó con éxito')
          } else {
            ShowSnackBar(data.data.messageSystem, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          ShowSnackBar('Error interno', 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
      }
    })
  }

  const onSubmit = async (data: LaundryModel) => {
    setLoading(true)
    data.campoadicionalnum1 = Number(data.campoadicionalnum1)
    data.campoadicionalnum2 = Number(data.campoadicionalnum2)
    data.campoadicionalnum3 = Number(data.campoadicionalnum3)
    data.empresa = data.empresaColaborador ? data.empresaColaborador : data.empresa
    data.telefono = data.telefonoColaborador ? data.telefonoColaborador : data.telefono
    data.email = data.emailColaborador ? data.emailColaborador : data.email
    data.usuarioId = user.id
    if (data.campoadicionalFec1) {
      const fechaLocal = new Date(data.campoadicionalFec1)
      const fechaUTC = getUTCDate(fechaLocal)
      data.campoadicionalFec1 = fechaUTC.toISOString()
    }

    if (data.campoadicionalFec2) {
      const fechaLocal2 = new Date(data.campoadicionalFec2)
      const fechaUTC2 = getUTCDate(fechaLocal2)
      data.campoadicionalFec2 = fechaUTC2.toISOString()
    }

    if (currentTabItem.idToEdit) {
      data.id = currentTabItem.idToEdit
      const response = await updateLaundry(data)
      if (!response.data.error) {
        reset()

        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-laundry',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar('Se actualizó el registro correctamente')
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    } else {
      const response = await createLaundry(data)
      if (!response.data.error) {
        reset()
        ShowSnackBar('Se creó con éxito')

        const obj: TabLavanderiaModel = {
          ...currentTabItem,

          content: {
            ...currentTabItem.content,
            headerPanel: 'table-laundry',
            detailPanel: 'tab-laundry',
          },
          showPanel: true,
          idToEdit: response.data.Id,
          currentExternalTab: 1,
        }
        changeCurrentTabItem(obj)
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    }

    setLoading(false)
  }
  const handleGenerate = async () => {
    setLoading(true)
    let id = currentTabItem.laundrySelected ? currentTabItem.laundrySelected[0]?.id : ''
    let value = currentTabItem.laundrySelected ? currentTabItem.laundrySelected[0] : null
    if (!id) return

    try {
      const response = await uploadTicket(id)
      if (!response.data.error) {
        const blob = new Blob([response.data], {type: 'application/pdf'})
        // Crea un enlace temporal y simula un clic para descargar el archivo
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Ticket_' + value.nroOrden // Ajusta el nombre del archivo según tus necesidades
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      ShowSnackBar('Error interno', 'error')
    }
  }

  const refreshTable = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      loadingTable: true,
      laundrySelected: [],
    }
    changeCurrentTabItem(obj)
  }

  const handleReception = async () => {
    const allOpg = currentTabItem.laundrySelected?.every((item) => item.estado === 'OPG')
    const sameCamp = currentTabItem.laundrySelected?.every(
      (item) => item.campamentoId === currentTabItem.laundrySelected[0].campamentoId,
    )
    const samePoint = currentTabItem.laundrySelected?.every(
      (item) => item.puntoId === currentTabItem.laundrySelected[0].puntoId,
    )
    if (!allOpg) {
      ShowSnackBar('Solo se pueden recepcionar órdenes en estado de ORDEN PREGENERADA', 'error')
      return
    } else if (!sameCamp) {
      ShowSnackBar('Las órdenes seleccionadas deben pertenecer al mismo campamento', 'error')
      return
    } else if (!samePoint) {
      ShowSnackBar(
        'Las órdenes seleccionadas deben pertenecer al mismo punto de lavandería',
        'error',
      )
      return
    } else {
      setShow(true)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          option='order'
          generateTicket={handleGenerate}
          loading={loading}
          textComponentBack='table-laundry'
          textComponentGo='form-laundry'
          reception={handleReception}
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-lavanderia-header-${currentTabItem.id}`}
              id={`panel-lavanderia-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-lavanderia-detail-${currentTabItem.id}`}
                    id={`panel-lavanderia-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
        {show && (
          <ModalReception
            show={show}
            setShow={setShow}
            arrayId={currentTabItem.laundrySelected?.map((item) => item.id) || []}
            getList={refreshTable}
            fromLaundry={true}
          />
        )}
      </form>
    </FormProvider>
  )
}

export default LaundryPageWrapper
